import projection from '../generated/pwd5m6f1.json';
import { AcceptanceManifest } from '../types';
export const pwd5m6f1AcceptanceManifest = projection as AcceptanceManifest;
